import { supabase } from "../../supabaseClient";

function cleanId(value) {
  return String(
    value || ""
  ).trim();
}

export async function fetchPartnerLearnerFacilitator(
  cohortLearnerId
) {
  const cleanCohortLearnerId =
    cleanId(cohortLearnerId);

  if (!cleanCohortLearnerId) {
    return null;
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "get_partner_learner_facilitator",
    {
      p_cohort_learner_id:
        cleanCohortLearnerId,
    }
  );

  if (error) {
    throw error;
  }

  if (Array.isArray(data)) {
    return data[0] || null;
  }

  return data || null;
}

export async function fetchPartnerLearnerFacilitatorOptions(
  cohortLearnerId
) {
  const cleanCohortLearnerId =
    cleanId(cohortLearnerId);

  if (!cleanCohortLearnerId) {
    return [];
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "get_partner_learner_facilitator_options",
    {
      p_cohort_learner_id:
        cleanCohortLearnerId,
    }
  );

  if (error) {
    throw error;
  }

  return Array.isArray(data)
    ? data
    : [];
}

export async function fetchPartnerLearnerFacilitators(
  cohortId = null
) {
  const { data, error } =
    await supabase.rpc(
      "get_partner_learner_facilitators",
      {
        p_cohort_id:
          cohortId || null,
      }
    );

  if (error) {
    throw error;
  }

  return Array.isArray(data)
    ? data
    : [];
}

export async function setPartnerLearnerFacilitator({
  cohortLearnerId,
  facilitatorPartnerMemberId,
}) {
  const cleanCohortLearnerId =
    cleanId(cohortLearnerId);

  const cleanFacilitatorId =
    cleanId(
      facilitatorPartnerMemberId
    );

  if (!cleanCohortLearnerId) {
    throw new Error(
      "A learner is required."
    );
  }

  if (!cleanFacilitatorId) {
    throw new Error(
      "A facilitator is required."
    );
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "set_partner_learner_facilitator",
    {
      p_cohort_learner_id:
        cleanCohortLearnerId,

      p_facilitator_partner_member_id:
        cleanFacilitatorId,
    }
  );

  if (error) {
    throw error;
  }

  return data;
}

export async function removePartnerLearnerFacilitator(
  cohortLearnerId
) {
  const cleanCohortLearnerId =
    cleanId(cohortLearnerId);

  if (!cleanCohortLearnerId) {
    throw new Error(
      "A learner is required."
    );
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "remove_partner_learner_facilitator",
    {
      p_cohort_learner_id:
        cleanCohortLearnerId,
    }
  );

  if (error) {
    throw error;
  }

  return data === true;
}